import Client from '../../../services/client';
import type { ConfirmPaymentInfo } from '../../../types';

interface ConfirmEasyWalletTransactionProps {
  confirmPaymentInfo: ConfirmPaymentInfo;
}

export const confirmEasyWalletTransaction = async ({
  confirmPaymentInfo,
}: ConfirmEasyWalletTransactionProps) => {
  const { data } = await Client.authApsWalletPay({
    transactionId: confirmPaymentInfo.merchantTransactionId,
    walletType: 'easy_wallet',
  });

  return data;
};
